import "./teamflow.css";
import Kanbas from "./Kanbas";
import store from "./Kanbas/store";
import { Provider } from "react-redux";

import { HashRouter, Route, Routes, Navigate } from "react-router-dom";
export default function App() {
  return (
    <HashRouter>
      <Provider store={store}>
        <div>
          <Routes>
            {" "}
            {/* <Route path="/" element={<Navigate to="Kanbas" />} /> */}
            <Route path="/" element={<Navigate to="/Kanbas/Account/Signin" replace />} />
            <Route path="/Kanbas/*" element={<Kanbas />} />
          </Routes>
        </div>{" "}
      </Provider>
    </HashRouter>
  );
}
